module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-balloon@3x-5b74fbb9e24e4f2800f537d87d4c3571.png";